import * as React from 'react';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {MessageContainer} from 'shells/message/message-container';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import type {CalendarSync} from 'nutshell-graphql-types';

import {CalendarConnectButtons} from '../../../setup/calendar/calendar-connect-buttons';

import {analyticsClient} from '../../../../analytics-client';

import styles from './connect.module.css';

type Props = {
    calendarSync: CalendarSync | null | undefined;
    refetchSyncStatus: () => Promise<any>;
    setPageAutoAdvance: (pageAutoAdvance: boolean) => void;
    onSuccess?: () => any;
    forceReauth?: boolean;
};

export function Connect(props: Props) {
    const [errorMessages, setErrorMessages] = React.useState<string[]>([]);

    const banners = (
        <div className={styles.banner}>
            <MessageContainer>
                {errorMessages.map((message) => (
                    <FlashBanner
                        key={message}
                        hasBorder={true}
                        type='error'
                        onHidden={() => {
                            setErrorMessages(errorMessages.filter((msg) => msg !== message));
                        }}
                    >
                        {message}
                    </FlashBanner>
                ))}
            </MessageContainer>
        </div>
    );

    return (
        <>
            {banners}
            <OnboardingBody title='Sign in to connect your calendar'>
                <div className={styles['initial-sync-ctas']}>
                    <CalendarConnectButtons
                        calendarSync={props.calendarSync}
                        errorMessages={errorMessages}
                        setErrorMessages={setErrorMessages}
                        refetchSyncStatus={props.refetchSyncStatus}
                        forceReauth={props.forceReauth}
                        onAuthStart={() => {
                            props.setPageAutoAdvance(false);
                        }}
                        onAuthSuccess={() => {
                            analyticsClient.track(
                                analyticsClient.EVENTS.TRACK_CONNECTED_CALENDAR_VIA_SCHEDULER
                            );
                            props.setPageAutoAdvance(true);

                            if (props.onSuccess) {
                                props.onSuccess();
                            }
                        }}
                    />
                </div>
            </OnboardingBody>
        </>
    );
}
